"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _useRecommendationHandset = require("../../../../hooks/recommendation/useRecommendationHandset");
var _services = require("../../../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var VariancePicker = function VariancePicker(_ref) {
  var handset = _ref.handset;
  var _useRecommendationHan = (0, _useRecommendationHandset.useRecommendationHandset)(handset),
    filters = _useRecommendationHan.filters,
    onVariantSelect = _useRecommendationHan.onVariantSelect;
  var colorVariants = filters.colorVariants,
    memoryVariants = filters.memoryVariants,
    selectedColor = filters.selectedColor,
    selectedMemory = filters.selectedMemory;
  var renderMemoryOptions = memoryVariants.length === 1 ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SelectInputWithMenuWithLabel, {
    fieldWrapper: {
      label: _services.locale.localeString('Recommendation.CapacityLabel'),
      width: 'full'
    },
    selectInputWithMenu: {
      id: "recommendation-handset-capacity",
      required: true,
      value: selectedMemory.value,
      onChange: function onChange(event) {
        onVariantSelect(handset.productId, event.target.value);
      },
      options: memoryVariants
    }
  }) : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SelectInputWithLabel, {
    fieldWrapper: {
      label: _services.locale.localeString('Recommendation.CapacityLabel'),
      width: 'full'
    },
    selectInput: {
      id: "recommendation-handset-dropdown-capacity",
      required: true,
      value: selectedMemory.value,
      onChange: function onChange(event) {
        onVariantSelect(handset.productId, event.target.value);
      },
      options: memoryVariants
    }
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ColorSelectWithLabel, {
    fieldWrapper: {
      label: _services.locale.localeString('Recommendation.ColorLabel'),
      width: 'full'
    },
    colorSelect: {
      id: "recommendation-handset-dropdown-color",
      value: selectedColor.value,
      onChange: function onChange(variantId) {
        onVariantSelect(handset.productId, variantId);
      },
      options: colorVariants === null || colorVariants === void 0 ? void 0 : colorVariants.filter(function (colorVariant) {
        return colorVariant.color;
      })
    }
  })), selectedMemory.text ? /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6
    }
  }, renderMemoryOptions) : null);
};
var _default = VariancePicker;
exports.default = _default;